module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABlSURBVHgB7dlRDYAwEATRLR5wgi00EDQgCAM4QQRUw4VkaDJPwc3nZdty3FuKrnXe84F+w5OiKYMzgGYAzQCaATQDaAbQhg+QJEmSJFFafqAPHGeKfOppBtAMoBlAM4BmAM0A2gvulgldMVn8TwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/larg/topicon.png
// module id = 2u0h
// module chunks = 1